var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SmartLink',{attrs:{"native":false,"to":_vm.signInFullPath}},[_c('TopNavigationElement',{attrs:{"text":_vm.$t('dictionary.register'),"additional-attrs":_vm.additionalAttrs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }